import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogTitle,
  Grid,
} from '@material-ui/core';
import React from 'react';

import { IAdserverOrder } from '~/src/dash/api/order';
import { IWithStylesProps } from '~/src/dash/types/props';
import { decorate } from '~/src/dash/utils/decorator';
import { LoadingView } from '~/src/dash/views/loading-view';

// this component is used to check if the user wants to include creatives when cloning an order
export interface IProps extends IWithStylesProps {
  active: boolean;
  order: IAdserverOrder;
  // calls the api from props
  activeModal: (includeCreatives: boolean) => Promise<any>;
  onClose: () => void;
  cloneLoading: boolean;
}

interface IState {
  updating: boolean;
}

export const ModalDialogIncludeCreativeView = decorate(
  {
    styles: (theme: any) => ({
      icon: {
        fontSize: '1rem',
        marginRight: '1rem',
      },
      error: {
        backgroundColor: theme.palette.error.dark,
      },
      message: {
        display: 'inline-flex',
        'align-items': 'center',
      },
    }),
  },
  class extends React.Component<IProps, IState> {
    state = {
      updating: false,
    };

    render() {
      const { updating } = this.state;
      const { activeModal, active, cloneLoading, onClose, order } = this.props;
      return !cloneLoading ? (
        <Grid>
          <Dialog
            open={active}
            onClose={onClose}
            disableBackdropClick={updating}
            disableEscapeKeyDown={updating}
            aria-labelledby='alert-dialog-title'
            aria-describedby='alert-dialog-description'
          >
            <DialogTitle>{`Include Cloning Creatives for ${order.Name}?`}</DialogTitle>
            <DialogActions>
              <Button
                onClick={() => {
                  activeModal(false);
                  onClose();
                }}
                color='primary'
                autoFocus
                disabled={updating}
              >
                No
              </Button>
              <Button
                onClick={() => {
                  activeModal(true);
                  onClose();
                }}
                disabled={updating}
              >
                Yes
                <span style={updating ? { opacity: 1 } : { opacity: 0 }}>
                  &nbsp;
                  <CircularProgress size={12} />
                </span>
              </Button>
            </DialogActions>
          </Dialog>
        </Grid>
      ) : (
        <LoadingView active={cloneLoading} text={'Cloning...'} />
      );
    }
  },
);
